import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PaymentIcon from '@mui/icons-material/Payment';
import PublicIcon from '@mui/icons-material/Public';
import VerifiedIcon from '@mui/icons-material/Verified';
import StarIcon from '@mui/icons-material/Star';
import SpeedIcon from '@mui/icons-material/Speed';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import GroupsIcon from '@mui/icons-material/Groups';

// Styled components
const FeaturePaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[8],
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  borderRadius: '50%',
  width: 80,
  height: 80,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  '& svg': {
    fontSize: 40,
  },
}));

// Feature data
const features = [
  {
    id: 1,
    title: 'Global Sourcing',
    description: 'Premium marble, granite, and epoxy from Italy, Spain, Turkey, and India',
    icon: <PublicIcon />
  },
  {
    id: 2,
    title: 'Quality Assurance',
    description: 'Rigorous quality checks for all materials including granite and epoxy finishes',
    icon: <VerifiedIcon />
  },
  {
    id: 4,
    title: 'Reliable Shipping',
    description: 'Safe and timely delivery of all materials worldwide',
    icon: <LocalShippingIcon />
  },
  {
    id: 6,
    title: 'Flexible Payment',
    description: 'Multiple payment options for your convenience',
    icon: <PaymentIcon />
  },
  {
    id: 7,
    title: 'Premium Selection',
    description: 'Curated collection of the finest stones from renowned quarries worldwide',
    icon: <WorkspacePremiumIcon />
  },
  {
    id: 8,
    title: 'Competitive Pricing',
    description: 'Best value for money without compromising on quality',
    icon: <PriceCheckIcon />
  },
  {
    id: 9,
    title: 'Fast Turnaround',
    description: 'Quick processing and delivery to meet your project deadlines',
    icon: <SpeedIcon />
  },
  {
    id: 10,
    title: 'Trusted Reputation',
    description: 'Years of experience serving satisfied customers globally',
    icon: <StarIcon />
  },
  {
    id: 12,
    title: 'Expert Team',
    description: 'Skilled professionals with extensive knowledge in stone industry',
    icon: <GroupsIcon />
  }
];

const Features = () => {
  return (
    <Box sx={{ pt: 3, pb: 0 }}>
      <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 1 }}>
        Why Choose Us
      </Typography>
      <Typography variant="subtitle1" gutterBottom align="center" color="textSecondary" sx={{ mb: 4 }}>
        We are committed to providing the highest quality products and exceptional service
      </Typography>
      
      <Grid container spacing={4}>
        {features.map((feature) => (
          <Grid item key={feature.id} xs={12} sm={6} md={4}>
            <FeaturePaper elevation={3}>
              <IconWrapper>
                {feature.icon}
              </IconWrapper>
              <Typography variant="h6" component="h3" gutterBottom>
                {feature.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {feature.description}
              </Typography>
            </FeaturePaper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Features; 